api = require '../api'

module.exports =
  getUploadPolicy: (id) ->
    api.sendAndReceiveRaw
      method: 'GET'
      path: '/protect_upload'
